"use client";

import { usePostHog } from "posthog-js/react";
import { useEffect } from "react";

import { UserNoDates } from "@/types/types";
import { getSubscriptionProperties } from "@/utils/subscriptionLevels/getSubscriptionProperties";

export function PostHogIdentify({ user }: { user: UserNoDates | null }) {
  const postHog = usePostHog();

  useEffect(() => {
    if (user !== null) {
      try {
        const subscriptionProperties = getSubscriptionProperties(
          user.stripeSubscriptionId
        );

        const isIdentified = postHog._isIdentified();
        if (!isIdentified) {
          const userCreatedAtDate = new Date(user.createdAtString);
          const userCreatedAtIsoString = userCreatedAtDate.toISOString();
          postHog.identify(user.dbId, {
            email: user.email,
            // Need to set createdAt for experiments that rely on it PostHog prefers dates to be in ISO 8601 format
            createdAt: userCreatedAtIsoString,
            ...subscriptionProperties,
          });
        }

        // Super properties stamp every client event; re-registered each load so they self-correct on upgrade/churn (reset() on sign-out clears)
        postHog.register(subscriptionProperties);
      } catch (e) {
        console.error(e);
      }
    }
  }, [postHog, user]);

  return <></>;
}
